import { useTranslation } from "react-i18next";

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    {
      icon: "ri-stack-line",
      title: t("feature1_title"),
      desc: t("feature1_desc"),
    },
    {
      icon: "ri-timer-flash-line",
      title: t("feature2_title"),
      desc: t("feature2_desc"),
    },
    {
      icon: "ri-book-open-line",
      title: t("feature3_title"),
      desc: t("feature3_desc"),
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-block px-3 py-1 border border-foreground-200 rounded-full text-xs text-foreground-600 font-medium mb-4">
            {t("features_label")}
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            {t("features_title1")}
          </h2>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            {t("features_title2")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-[500px] mx-auto">
            {t("features_subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100 rounded-xl p-6 md:p-8 border border-foreground-100/30 hover:bg-primary-50 hover:border-primary-200 transition-all duration-300 group cursor-default"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
              <span className="inline-block mt-3 text-xs text-primary-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                Mehr erfahren →
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}